import { j as o } from "../../../jsx-runtime-82a9ddf6.js";
const C = ({ width: r = 20, height: e = 20, className: n, style: t }) => /* @__PURE__ */ o.jsx(
  "svg",
  {
    width: r,
    height: e,
    className: n,
    style: t,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ o.jsxs("g", { id: "Icons / Balance", children: [
      /* @__PURE__ */ o.jsx("path", { id: "Vector", d: "M14.1666 6.66666V4.16666C14.1666 3.94565 14.0788 3.73369 13.9225 3.57741C13.7662 3.42113 13.5543 3.33333 13.3333 3.33333H4.99992C4.55789 3.33333 4.13397 3.50892 3.82141 3.82148C3.50885 4.13404 3.33325 4.55797 3.33325 4.99999C3.33325 5.44202 3.50885 5.86595 3.82141 6.17851C4.13397 6.49107 4.55789 6.66666 4.99992 6.66666H14.9999C15.2209 6.66666 15.4329 6.75446 15.5892 6.91074C15.7455 7.06702 15.8333 7.27898 15.8333 7.5V10M15.8333 13.3333V15.8333C15.8333 16.0543 15.7455 16.2663 15.5892 16.4226C15.4329 16.5789 15.2209 16.6667 14.9999 16.6667H4.99992C4.55789 16.6667 4.13397 16.4911 3.82141 16.1785C3.50885 15.8659 3.33325 15.442 3.33325 15V4.99999", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ o.jsx("path", { id: "Vector_2", d: "M16.6667 10V13.3333H13.3334C12.8914 13.3333 12.4675 13.1577 12.1549 12.8452C11.8423 12.5326 11.6667 12.1087 11.6667 11.6667C11.6667 11.2246 11.8423 10.8007 12.1549 10.4882C12.4675 10.1756 12.8914 10 13.3334 10H16.6667Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
    ] })
  }
);
export {
  C as BalanceIcon
};
